import React from 'react';
import {Button} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';

const styles = {
    root: {
        textTransform: 'none',
        borderRadius: '8px',
        fontWeight: 600,
        fontSize: '0.9rem',
        padding: '8px 16px',
        minWidth: 'auto',
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        letterSpacing: '0.02em',
    },
    blueFilled: {
        backgroundColor: '#2563EB',
        color: '#FFFFFF',
        border: '1px solid transparent',
        '&:hover': {
            backgroundColor: '#1D4ED8',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.2), 0 2px 4px -1px rgba(37, 99, 235, 0.1)',
        },
    },
    greenFilled: {
        backgroundColor: '#10B981',
        color: '#FFFFFF',
        border: '1px solid transparent',
        '&:hover': {
            backgroundColor: '#059669',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 6px -1px rgba(16, 185, 129, 0.2), 0 2px 4px -1px rgba(16, 185, 129, 0.1)',
        },
    },
    darkBlueFilled: {
        backgroundColor: '#1E293B',
        color: '#FFFFFF',
        border: '1px solid transparent',
        '&:hover': {
            backgroundColor: '#0F172A',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 6px -1px rgba(30, 41, 59, 0.2), 0 2px 4px -1px rgba(30, 41, 59, 0.1)',
        },
    },
    blackFilled: {
        backgroundColor: '#111827',
        color: '#FFFFFF',
        border: '1px solid transparent',
        '&:hover': {
            backgroundColor: '#000000',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 6px -1px rgba(17, 24, 39, 0.2), 0 2px 4px -1px rgba(17, 24, 39, 0.1)',
        },
    },
    grayOutlined: {
        color: '#4B5563',
        backgroundColor: 'transparent',
        border: '1px solid #D1D5DB',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#F3F4F6',
            color: '#1F2937',
            transform: 'translateY(-1px)',
            borderColor: '#9CA3AF',
        },
    },
    blueOutlined: {
        color: '#2563EB',
        backgroundColor: 'transparent',
        border: '1px solid #BFDBFE',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#EFF6FF',
            color: '#1D4ED8',
            transform: 'translateY(-1px)',
            borderColor: '#93C5FD',
        },
    },
    redOutlined: {
        color: '#EF4444',
        backgroundColor: 'transparent',
        border: '1px solid #FECACA',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#FEF2F2',
            color: '#DC2626',
            transform: 'translateY(-1px)',
            borderColor: '#FCA5A5',
        },
    },
    greenOutlined: {
        color: '#10B981',
        backgroundColor: 'transparent',
        border: '1px solid #A7F3D0',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#ECFDF5',
            color: '#059669',
            transform: 'translateY(-1px)',
            borderColor: '#6EE7B7',
        },
    },
    purpleFilledBig: {
        color: '#FFFFFF',
        backgroundColor: '#8B5CF6',
        padding: '12px 24px',
        fontWeight: '600',
        fontSize: '1rem',
        border: '1px solid transparent',
        '&:hover': {
            backgroundColor: '#7C3AED',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 6px -1px rgba(139, 92, 246, 0.2), 0 2px 4px -1px rgba(139, 92, 246, 0.1)',
        },
    },
    grayFilledBig: {
        color: '#ffffff',
        backgroundColor: '#6B7280',
        padding: '12px 24px',
        fontWeight: '600',
        fontSize: '1rem',
        border: '1px solid transparent',
        '&:hover': {
            backgroundColor: '#4B5563',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 6px -1px rgba(107, 114, 128, 0.2), 0 2px 4px -1px rgba(107, 114, 128, 0.1)',
        },
    },
    sizeSmall: {
        padding: '6px 12px',
        fontSize: '0.8rem',
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
    },
    iconStart: {
        display: 'flex',
        alignItems: 'center',
    },
    iconEnd: {
        display: 'flex',
        alignItems: 'center',
    },
};

const CustomButton = withStyles(styles)(({
                                             classes,
                                             variant = 'blueFilled',
                                             size = 'medium',
                                             icon,
                                             iconPosition = 'start',
                                             children,
                                             ...props
                                         }) => {
    const buttonClass = `${classes.root} ${classes[variant]} ${size === 'small' ? classes.sizeSmall : ''}`;

    return (
        <Button
            className={buttonClass}
            {...props}
        >
      <span className={classes.icon}>
        {icon && iconPosition === 'start' && (
            <span className={classes.iconStart}>{icon}</span>
        )}
          {children}
          {icon && iconPosition === 'end' && (
              <span className={classes.iconEnd}>{icon}</span>
          )}
      </span>
        </Button>
    );
});

export default CustomButton;
